import { render, staticRenderFns } from "./TabCockpit.vue?vue&type=template&id=6c4f14cf"
import script from "./TabCockpit.vue?vue&type=script&lang=ts"
export * from "./TabCockpit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports